import React, {useEffect,useRef,useState} from 'react';
import { ResponseResult, Student, RouteParam } from '../../types';
import {Card, Row, Col, Button, Form, Input, message } from 'antd';
import { request } from '../../services/Request';
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom';

function ApplicantEdit(){

    const [student, setStudent] = useState<Partial<Student>>({});
    const form:any = useRef(null);
    const { id } = useParams<RouteParam>();

    useEffect(()=>{
        getApplicant();
    }, []);

    useEffect(() => {
        form.current.resetFields()
      }, [student])


    const getApplicant = () => {
        Swal.fire("Editar aspirante", "Cargando...");
        Swal.showLoading();  
        request("/api/applicant/"+id,{
        })
        .then((result:ResponseResult)=>{
            Swal.close();
            if(result.data){
                setStudent(result.data);
            }else{
                Swal.fire("Editar aspirante", "Ocurrió un error al recuperar el aplicante", "error");
            }
        })
    }

    const submit = (values: Student) => {
        Swal.fire("Editar aspirante", "Guardando aspirante...");
        Swal.showLoading();  
        request("/api/applicant/"+id,{
            method:'PUT',
            body: JSON.stringify(values)
        })
        .then((result:ResponseResult)=>{
            if(result.data){
                window.location.href = "/applicants";
            }else{
                Swal.fire("Editar aspirante", "Ocurrió un error al guardar el aplicante", "error");
            }
        })
    }

    const onFinishFailed = (_errorInfo:unknown) => {
        message.error('Es necesario completar todos los campos');
    };

    return (
        <div>
            <Row>
                <Col xs={12} md={{span:10,offset:7}}>
                    <Card title={"Nuevo aspirante"}>
                        <Form onFinish={submit} initialValues={student} ref={form} onFinishFailed={onFinishFailed}>
                            <Form.Item label="Nombre del alumno" name="name" rules={[
                                        {
                                            required: true,
                                            message: 'Ingresa el nombre',
                                        },
                                    ]}>
                                <Input value={student.name} />
                            </Form.Item>
                            <Form.Item label="Apellido paterno" name="first_lastname" rules={[
                                        {
                                            required: true,
                                            message: 'Ingresa el apellido paterno',
                                        },
                                    ]}>
                                <Input value={student.first_lastname} />
                            </Form.Item>
                            <Form.Item label="Apellido materno" name="second_lastname" rules={[
                                        {
                                            required: true,
                                            message: 'Ingresa el apellido materno',
                                        },
                                    ]}>
                                <Input value={student.second_lastname} />
                            </Form.Item>
                            <Form.Item label="CURP" name="curp" rules={[
                                        {
                                            required: true,
                                            message: 'Ingresa el CURP',
                                        },
                                    ]}>
                                <Input value={student.curp}/>
                            </Form.Item>
                            <Form.Item label="Email" name="email" rules={[
                                        {
                                            required: true,
                                            message: 'Ingresa el correo',
                                        },
                                    ]}>
                                <Input value={student.email}/>
                            </Form.Item>
                            <Form.Item label="Teléfono" name="phone">
                                <Input value={student.phone} />
                            </Form.Item>
                            
                            <Button type="primary" htmlType="submit">Guardar</Button>
                            <Button ghost type="primary" href="/applicants">Regresar</Button>                                
                        </Form>
                    </Card>
                </Col>  
            </Row>
        </div>
    )
}

export default ApplicantEdit;